import { render, staticRenderFns } from "./StockInfoPanels.vue?vue&type=template&id=1ee0dfed&scoped=true&"
import script from "./StockInfoPanels.vue?vue&type=script&lang=js&"
export * from "./StockInfoPanels.vue?vue&type=script&lang=js&"
import style0 from "./StockInfoPanels.vue?vue&type=style&index=0&id=1ee0dfed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee0dfed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
